// import { } from "../../http/RenewalHttp";
import { getCurrentMemberDashboard } from "../../../http/renewalHttp/RenewalMemberHttp";
import Div from "../../../components/Div"
// import RenewalHistory from "../../components/Dashboards/RenewalHistory"
// import RenewalStatus from "../../components/Dashboards/RenewalStatus"
import RenewalTeam from "../../../components/Dashboards/RenewalTeam"
import { useCallback, useEffect, useState } from "react"
import Input from "../../../components/Input"
import { getResellerRenewalDashboard } from "../../../http/renewalHttp/RenewalMemberHttp";



export default function RenewalMemberDashboard() {

    // const [teamDomain, setTeamDomain] = useState(false);

    // const [segmentCount, setSegmentCount] = useState(false);

    const [currentDashboard, setCurrentDashboard] = useState(false);
    const [resellerDashboard, setResellerDashboard] = useState(false);


    const getCurrentYearMonth = () => {
        const date = new Date();
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
      };

    const [month, setMonth] = useState(getCurrentYearMonth)

    function handleMonthChange(event) {
        const filterMonth = event.target.value
        setMonth(filterMonth)
    }
    // const getTeamData = async () => {
    //     try {
    //         const response = await getRenewalTeamDomainCount()
    //         console.log(response)

    //         const columns = <> <th style={{
    //             position: "sticky",
    //             top: 0,
    //             backgroundColor: "#f1f1f1",
    //             zIndex: 100,
    //         }}>Team Member Email</th>
    //             <th style={{
    //                 position: "sticky",
    //                 top: 0,
    //                 backgroundColor: "#f1f1f1",
    //                 zIndex: 100,
    //             }}>Domain Count</th>
    //         </>

    //         setTeamDomain({
    //             data: response.domains,
    //             columns: columns
    //         });

    //     } catch (error) {
    //         console.log(error)
    //     }
    // }

    // const getSegmentCountData = async () => {
    //     try {
    //         const response = await getRenewalSegmentCount()
    //         console.log(response)

    //         const columns = <> <th style={{
    //             position: "sticky",
    //             top: 0,
    //             backgroundColor: "#f1f1f1",
    //             zIndex: 100,
    //         }}>Segments</th>
    //             <th style={{
    //                 position: "sticky",
    //                 top: 0,
    //                 backgroundColor: "#f1f1f1",
    //                 zIndex: 100,
    //             }}>Segment Count</th>
    //         </>

    //         setSegmentCount({
    //             data: response.segments,
    //             columns: columns
    //         });

    //     } catch (error) {
    //         console.log(error)
    //     }
    // }

    // const getAggrementCountData = async () => {
    //     try {
    //         const response = await getRenewalAggrementCount()
    //         console.log(response)

    //         const columns = <> <th style={{
    //             position: "sticky",
    //             top: 0,
    //             backgroundColor: "#f1f1f1",
    //             zIndex: 100,
    //         }}>Aggrement Status</th>
    //             <th style={{
    //                 position: "sticky",
    //                 top: 0,
    //                 backgroundColor: "#f1f1f1",
    //                 zIndex: 100,
    //             }}>Aggment Count</th>
    //         </>

    //         setAggrementCount({
    //             data: response.aggrements,
    //             columns: columns
    //         });

    //     } catch (error) {
    //         console.log(error)
    //     }
    // }

    // const getFlagStatusCoutData = async () => {
    //     try {
    //         const response = await getRenewalFlagsCount()
    //         console.log(response)

    //         const columns = <> <th style={{
    //             position: "sticky",
    //             top: 0,
    //             backgroundColor: "#f1f1f1",
    //             zIndex: 100,
    //         }}>Flag Status</th>
    //             <th style={{
    //                 position: "sticky",
    //                 top: 0,
    //                 backgroundColor: "#f1f1f1",
    //                 zIndex: 100,
    //             }}>Flag Count</th>
    //         </>

    //         setFlagsCount({
    //             data: response.flags,
    //             columns: columns
    //         });

    //     } catch (error) {
    //         console.log(error)
    //     }
    // }

    const getCurrentDashboardData = async () => {
        try {
            const response = await getCurrentMemberDashboard()
            console.log(response)

            const columns = <> <th style={{
                position: "sticky",
                top: 0,
                backgroundColor: "#f1f1f1",
                zIndex: 100,
            }}>Reseller</th>
                <th style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#f1f1f1",
                    zIndex: 100,
                }}>Count</th>
            </>

            setCurrentDashboard({
                data: response.flags,
                columns: columns
            });

        } catch (error) {
            console.log(error)
        }
    }

    const getResellerCurrentDashboardData = useCallback( async () => {
        try {
            const response = await getResellerRenewalDashboard(month)
            console.log(response)

            const columns = <> <th style={{
                position: "sticky",
                top: 0,
                backgroundColor: "#f1f1f1",
                zIndex: 100,
            }}>Monthly</th>
                <th style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#f1f1f1",
                    zIndex: 100,
                }}>Count</th>
            </>

            setResellerDashboard({
                data: response.domain,
                columns: columns
            });

        } catch (error) {
            console.log(error)
        }
    },[month])


    useEffect(() => {

        // getTeamData()
        // getAggrementCountData()
        // getSegmentCountData()
        // getFlagStatusCoutData()
        getCurrentDashboardData()
        getResellerCurrentDashboardData()

    }, [getResellerCurrentDashboardData]);


    return <>
        <Div className='row'>
            {/* <Div style={{ margin: '50px' }}>
                <RenewalHistory />
            </Div>
            <Div style={{ margin: '50px' }}>
                <RenewalStatus />
            </Div> */}
            {/* <Div className='col-4' style={{ margin: '50px' }}>
                <RenewalTeam title='Renewal Team Domain' data={teamDomain.data}
                    columns={teamDomain.columns} tag='team' />
            </Div> */}

            {/* <Div className='col-4' style={{ margin: '50px' }}>
                <RenewalTeam title='Segment Dashboard' data={segmentCount.data}
                    columns={segmentCount.columns} tag='segments' />
            </Div>
        </Div>

        <Div className='row'>
            <Div className='col-4' style={{ margin: '50px' }}>
                <RenewalTeam title='Aggrement Status' data={aggrementCount.data}
                    columns={aggrementCount.columns} tag='aggrements' />
            </Div>

            <Div className='col-4' style={{ margin: '50px' }}>
                <RenewalTeam title='Flag Status' data={flagsCount.data}
                    columns={flagsCount.columns} tag='flags' />
            </Div> */}

 <Div>
                <Input type='month' name='month' id='month' style={{ marginLeft: '50px' }} value={month}
                                        onChange={handleMonthChange}
                                    />
            </Div>
        </Div>

        <Div className='row'>
            <Div className='col-4' style={{ margin: '50px' }}>
                <RenewalTeam title='Monthly Dashboard' data={currentDashboard.data}
                    columns={currentDashboard.columns} tag='member' />
            </Div>
            <Div className='col-4' style={{ margin: '50px' }}>
                <RenewalTeam title='Reseller Dashboard' data={resellerDashboard.data}
                    columns={resellerDashboard.columns} tag='reseller_member' />
            </Div>

        </Div>

          
  
    </>
}